import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { PREFERRED_PARTNERS } from './DistributionPartners';

export const PartnerLogoRow = () => (
  <section className="py-12 bg-slate-50 border-y border-slate-100" data-testid="home-partner-logos">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row lg:items-center gap-8">
      <div className="lg:w-1/3">
        <p className="text-xs font-semibold tracking-widest uppercase text-orange-500 mb-2">Authorized Distribution</p>
        <h2 className="text-base md:text-lg font-bold text-[#1e2d3b]">
          CTRL aviation GSTE is available worldwide through our preferred distribution partners.
        </h2>
        <Link to="/distribution" className="inline-flex items-center mt-3 text-sm font-semibold text-blue-600 hover:text-blue-800" data-testid="home-partner-logos-link">
          All distributors <ArrowRight className="w-4 h-4 ml-1" />
        </Link>
      </div>
      <div className="flex-1 grid grid-cols-2 gap-6">
        {PREFERRED_PARTNERS.map((p) => (
          <a
            key={p.id}
            href={p.website}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`home-partner-logo-${p.id}`}
            className="bg-white rounded-2xl border border-slate-200 hover:border-blue-500 transition-colors duration-300 h-28 flex items-center justify-center px-8"
          >
            <img src={p.logo} alt={p.name} className="max-h-14 w-auto max-w-full object-contain" loading="lazy" />
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default PartnerLogoRow;
